import styled from 'styled-components'

const ButtonContainer = styled.div`
	display: flex;
	margin: 0 -15px;
`

export default {
	ButtonContainer,
}